import { render, staticRenderFns } from "./CmgShimmer.vue?vue&type=template&id=b787a4b0&scoped=true&lang=pug&"
import script from "./cmg-shimmer.ts?vue&type=script&lang=ts&"
export * from "./cmg-shimmer.ts?vue&type=script&lang=ts&"
import style0 from "./CmgShimmer.vue?vue&type=style&index=0&id=b787a4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b787a4b0",
  null
  
)

export default component.exports